import type { ReactNode } from "react";
import { AuthProvider, type SignInReturnHandler } from "src/infrastructure/auth";
import { ThemeProvider } from "src/providers/ThemeProvider";
import { QueryProvider } from "src/providers/QueryProvider";

/**
 * Root provider composition, mirroring insights-home's src/app/providers.tsx
 * shape (AuthProvider > ThemeProvider > QueryProvider > ...). Sits outside
 * RouterProvider — none of these need routing context, so this doesn't have
 * to nest inside the router the way page content does. `onSignInReturn` is
 * how auth, from outside the router, still moves it after sign-in.
 */
export function AppProviders({
  children,
  onSignInReturn,
}: {
  children: ReactNode;
  onSignInReturn: SignInReturnHandler;
}) {
  return (
    <AuthProvider onSignInReturn={onSignInReturn}>
      <ThemeProvider>
        <QueryProvider>{children}</QueryProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}
